import { render, staticRenderFns } from "./FailedTripCard.vue?vue&type=template&id=1dc98a3a"
import script from "./FailedTripCard.vue?vue&type=script&lang=ts"
export * from "./FailedTripCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports